<template>
  <div :id="id">
    <label
      :for="id + 'color-picker'"
      :title="label"
      class="text-truncate d-block"
      v-if="label"
      >{{label}}<small v-if="v.required !== undefined">*</small></label>
    <font-awesome-icon
      :id="id + 'font-awesome-icon-edit'"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      :id="id + 'font-awesome-icon-question-circle'"
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
      />
    <v-swatches
      :id="id + 'color-picker'"
      @input="valueData = $event; $emit('input', $event)"
      :value="valueData || defaultValue"
      :swatches="swatches"
      :class="{'is-invalid': v.$error}"
    />
    <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
  </div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
export default {
  data () {
    return {
      valueData: ''
    }
  },
  props: {
    id: {
      type: String,
      default: 'lm-color-picker'
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    swatches: {
      type: Array | String,
      default: 'text-advanced'
    },
    defaultValue: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VSwatches
  }
}
</script>
